import { useFetchWorkspaceMember } from "@api/workspaceMember.api";
import { useUserStatus } from "../useUserStatus";

export function useCurrentUserWorkspaceMember() {
    const { data: userStatus } = useUserStatus();
    const member = useFetchWorkspaceMember(userStatus?.user.id);

    return member.data ?? null;
}
